import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

const buildHeaderInfo = (
  entityName?: string | null,
  entityAddressLine1?: string | null,
  entityAddressLine2?: string | null,
  taxNumber?: string | null
): string[] => {
  const lines: string[] = [];

  if (entityName) {
    lines.push(entityName);
  }

  const address = [entityAddressLine1, entityAddressLine2].filter(Boolean).join(', ');
  if (address) {
    lines.push(address);
  }

  if (taxNumber) {
    lines.push(`MST: ${taxNumber}`);
  }

  return lines;
};

export const useQuyDoiDonViTinhChiTietExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity, entityUnit } = useAuth();

  const exportToExcel = async () => {
    if (!entity?.slug) {
      toast({
        description: 'Vui lòng chọn một pháp nhân trước khi kết xuất dữ liệu.',
        variant: 'destructive'
      });
      return;
    }

    setIsExporting(true);
    try {
      const { exportQuyDoiDonViTinhChiTietFromApi } = await import('../utils/export-excel');
      const headerInfo = buildHeaderInfo(
        entityUnit?.entity_line21 || entity?.name,
        entityUnit?.entity_line31,
        entityUnit?.entity_line32,
        entityUnit?.ma_so_thue
      );

      await exportQuyDoiDonViTinhChiTietFromApi({
        entitySlug: entity.slug,
        excelOptions: {
          headerInfo
        }
      });
    } catch (error) {
      console.error('Failed to export QuyDoiDonViTinhChiTiet:', error);
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
